import type { Point2d } from ".."
import { isPointOnSegment } from "./isPointOnSegment"
import { doSegmentsIntersect } from "../../2d/collision/doSegmentsIntersect"
import type { Face2dComputed, Edge2dComputed } from "../../mesh"
import { faceToEdges } from "../transmute/faceToEdges"

export const isPointInPolygon = (
  point: Point2d,
  polygon: Face2dComputed,
): boolean => {
  const edges = faceToEdges(polygon)
  if (edges.some((edge) => isPointOnSegment(point, edge))) {
    return false
  }
  const ray: Edge2dComputed = {
    p1: point,
    p2: { x: 1e12, y: point.y },
  }
  const knownPoints = new Set()
  const intersectedEdges = edges.filter((edge) => {
    const { p1, p2 } = edge
    if (knownPoints.has(p1) || knownPoints.has(p2)) {
      return false
    }
    if (isPointOnSegment(p1, ray)) knownPoints.add(p1)
    if (isPointOnSegment(p2, ray)) knownPoints.add(p2)
    const doesIntersect = doSegmentsIntersect(ray, edge)

    return doesIntersect
  })

  return intersectedEdges.length % 2 === 1
}

export const isPointInPolygonInclusive = (
  point: Point2d,
  polygon: Face2dComputed,
): boolean => {
  const edges = faceToEdges(polygon)
  if (edges.find((edge) => isPointOnSegment(point, edge))) {
    return true
  }

  return isPointInPolygon(point, polygon)
}
